import { Select } from "../Select/Select"

interface DatePickerProps {
	date: Date;
	onDateChange: (date: Date) => void;
}

export const DatePicker = ({ date, onDateChange }: DatePickerProps) => {
	const monthOptions = [
		{ label: 'January', value: 1 },
		{ label: 'February', value: 2 },
		{ label: 'March', value: 3 },
		{ label: 'April', value: 4 },
		{ label: 'May', value: 5 },
		{ label: 'June', value: 6 },
		{ label: 'July', value: 7 },
		{ label: 'August', value: 8 },
		{ label: 'September', value: 9 },
		{ label: 'October', value: 10 },
		{ label: 'November', value: 11 },
		{ label: 'December', value: 12 },
	];

	const getDaysInMonth = (month: number, year: number) => {
		return new Date(year, month, 0).getDate();
	};

	const currentMonth = date.getMonth() + 1;
	const currentYear = date.getFullYear();
	const daysInMonth = getDaysInMonth(currentMonth, currentYear);

	const dayOptions = Array.from({ length: daysInMonth }, (_, i) => ({
		label: String(i + 1),
		value: i + 1,
	}));

	const handleMonthChange = (event: { detail: { value: string } }) => {
		const newMonth = Number(event.detail.value) - 1;
		const newDate = new Date(date);
		newDate.setMonth(newMonth);

		// Ensure day is valid for new month
		const maxDay = getDaysInMonth(newMonth + 1, newDate.getFullYear());
		if (newDate.getDate() > maxDay) {
			newDate.setDate(maxDay);
		}

		onDateChange(newDate);
	};

	const handleDayChange = (event: { detail: { value: string } }) => {
		const newDay = Number(event.detail.value);
		const newDate = new Date(date);
		newDate.setDate(newDay);
		onDateChange(newDate);
	};

	return (
		<div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
			<Select
				options={monthOptions}
				value={currentMonth}
				onChange={handleMonthChange}
			/>
			<Select
				options={dayOptions}
				value={date.getDate()}
				onChange={handleDayChange}
			/>
		</div>
	)
}